import { useEffect, useRef } from "react";
import Hls from "hls.js";

// Plays an HLS (.m3u8) stream: native where supported (Safari), hls.js elsewhere.
export function HlsVideo({ src, poster, className }: { src: string; poster?: string; className?: string }) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
      return;
    }
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
      return () => hls.destroy();
    }
  }, [src]);

  return <video ref={ref} poster={poster} controls playsInline preload="none" className={className} />;
}
